export default __webpack_public_path__ + "static/media/pause.2e96ce56.svg";